import { createContext, useContext, useEffect, useState } from "react";
import { collection, query, where, getDocs, doc, getDoc  } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "./AuthContext";
import { CLUB_ID } from "../config/club";

const SessionContext = createContext();

export function SessionProvider({ children }) {
    const { user, loading } = useAuth();
    const [sessionId, setSessionId] = useState(null);
    const [session, setSession] = useState(null);
    const [sessionReady, setSessionReady] = useState(false);
    const clubId = CLUB_ID;

    useEffect(() => {
        if (loading || !user) return;

        const autoPickSession = async () => {
            if (sessionId) {
                setSessionReady(true);
                return;
            }

            const q = query(
                collection(db, "clubs", clubId, "sessions"),
                where("status", "==", "active")
            );

            const snap = await getDocs(q);

            if (snap.size === 1) {
                const docSnap = snap.docs[0];
                setSessionId(docSnap.id);
                setSession(docSnap.data());
            }

            // 🔑 VERY IMPORTANT
            setSessionReady(true);
        };

        autoPickSession();
    }, [user, loading, sessionId]);

    useEffect(() => {
        if (!sessionId) return;

        const loadSession = async () => {
            const ref = doc(db, "clubs", clubId, "sessions", sessionId);
            const snap = await getDoc(ref);
            if (snap.exists()) {
                setSession(snap.data());
            }
        };

        loadSession();
    }, [sessionId]);

    return (
        <SessionContext.Provider
            value={{
                sessionId,
                session,
                setSessionId,
                setSession,
                sessionReady, // 👈 expose this
                clubId
            }}
        >
            {children}
        </SessionContext.Provider>
    );
}


export const useSession = () => useContext(SessionContext);
